import { useRef } from 'react';
import Player from 'components/3catinfo/Player';
import clsx from 'clsx';
import styles from '../contingutEstatic.module.scss';

const Video = (props) => {
    const { id } = props;
    const playerRef = useRef();
    const stylesMedia = clsx({
        [styles.media]: true,
        [styles.mediaVideo]: true,
        [props.class]: !!props.class
    });

    return (
        <div className={stylesMedia} data-testid='contingut-parsejat-media-video'>
            <Player id={id} estils='noticia' ref={playerRef} playerVideoTagId={`contingut-parsejat-${id}`} />
        </div>
    );
};

export default Video;
